/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 17/11/2023
 */

import { Backdrop, CircularProgress, Rating, Typography } from '@mui/material'
import React, { useContext, useRef } from 'react'
import CheckoutContext from '../../Context/CheckoutContext';
import { SET_RESOURCE } from '../../Pages/CheckoutPage';
import styles from "./ProfessionalSelect.module.css"
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation } from "swiper";
import { isMobile } from 'react-device-detect';
import { useLazyGetResourceByAreaDateTimeQuery } from '../../Store/Services/ResourceService';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';

const ProfessionalSelect = ({ catId }) => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);
    const profPrevRef = useRef(null);
    const profNextRef = useRef(null);

    const [professionals, setProfessionals] = useState([])

    const [searchParams, setSearchParams] = useSearchParams();

    const [getProfs, { data, isSuccess ,isLoading }] = useLazyGetResourceByAreaDateTimeQuery();
    
    const getResources = async () => {
        try {
            const profs = await getProfs({
                areaId: checkoutData.areaId,
                calId: checkoutData.dateId,
                slotId: checkoutData.timeSlotId,
                catId: catId
            }).unwrap()
            setProfessionals(profs)
            
        } catch (error) {
            setProfessionals([])
            onResourceSelect(0)
        }
    }

    useEffect(() => {
        if(checkoutData.timeSlotId && checkoutData.dateId){
            getResources()
        }
    }, [checkoutData.timeSlotId, checkoutData.dateId])

    const onResourceSelect = (id) => {
        dispatch({ type: SET_RESOURCE, payload: id})
    }

    return (
        <div className={styles.selectionContainer}>
            {isLoading && (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <Swiper
                slidesPerView={isMobile ? 2 : 3}
                spaceBetween={10}
                freeMode={true}
                modules={[Navigation]}
                navigation={{
                    prevEl: profPrevRef.current,
                    nextEl: profNextRef.current,
                }}
            >
                <SwiperSlide
                    className={`${styles.profCard} ${checkoutData.resourceId == 0 && styles.profCardSelected}`}
                    onClick={() => onResourceSelect(0)}
                >
                    <img className={styles.profImg} src={require("../../Assets/people.png")} alt='auto asign' loading='lazy' />
                    <Typography className={styles.profName}>Auto Asign</Typography>
                    <div>
                        <Typography className={styles.profDesc}>We will asign the best professional</Typography>
                    </div>
                </SwiperSlide>
                {isSuccess && professionals.map(data => (
                    <SwiperSlide
                        key={data.resourceId}
                        className={`${styles.profCard} ${checkoutData.resourceId == data.resourceId && styles.profCardSelected}`}
                        onClick={() => onResourceSelect(data.resourceId)}
                    >
                        {/* <img className={styles.profImg} src={data.avatar || `${process.env.REACT_APP_IMAGE_URL}E_SERVICE/User.png`} alt={data.name} /> */}
                        <img className={styles.profImg} src={data.pic ? `${process.env.REACT_APP_IMAGE_URL}${data.pic}` : `${process.env.REACT_APP_IMAGE_URL}E_SERVICE/User.png`} alt={data.name} loading='lazy' />
                        <Typography className={styles.profName}>{data.name}</Typography>
                        <Rating className={styles.rating} size='small' value={data.rating} readOnly />
                        <div className={styles.profDesc}>
                            {/* <Typography>{data.experiance} years of Experience</Typography>
                            <Typography>{data.age} years old</Typography> */}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div ref={profPrevRef} className="swiper-button-prev"></div>
            <div ref={profNextRef} className="swiper-button-next"></div>
        </div>
    )
}

export default ProfessionalSelect